const set = {
	setCarTypes: "preferences/carTypes/setCarTypes",
	setBodyTypesForCarsTypes: "preferences/carTypes/setBodyTypes",
};

const constants = Object.seal(set);
export default constants;
